import { isFullUser } from 'twitter-d';
export class User {
    constructor(user) {
        if (!isFullUser(user)) {
            throw new Error('Twitter user must be a full user object');
        }
        this.data = user;
    }
    get name() {
        return this.data.name;
    }
    get screen_name() {
        return this.data.screen_name;
    }
    get url() {
        return `https://twitter.com/${this.data.screen_name}`;
    }
    get profileImageUrl() {
        return this.data.profile_image_url_https;
    }
    get verified() {
        return this.data.verified;
    }
}
//# sourceMappingURL=user.js.map